import React, { useEffect, useRef, useState } from 'react';
import {
  Container,
  Content,
  Title,
  LogoImg,
  Description,
  SectionWrapper,
  Table
} from './styled';

import logo from '../../assets/braspress-logo-azul.jpg';

const DeclarationForm = () => {
  const [collectSenderData, setCollectSenderData] = useState({});
  const [collectRecipientData, setCollectRecipientData] = useState({});
  const componentRef = useRef(null);

  useEffect(() => {
    const collectSender = localStorage.getItem('@Braspress:collectSenderData');
    const collectRecipient = localStorage.getItem(
      '@Braspress:collectRecipientData'
    );

    if (collectSender) {
      setCollectSenderData(JSON.parse(collectSender));
    }

    if (collectRecipient) {
      setCollectRecipientData(JSON.parse(collectRecipient));
    }
  }, []);

  return (
    <Container>
      <Content ref={componentRef}>
        <Title>FORMULÁRIO DE DECLARAÇÃO DE CONTEÚDO DE MERCADORIA</Title>

        <LogoImg src={logo} alt="Braspress" />

        <Description>
          Declaro para os devidos fins, e sob as penas legais que entregamos à
          BRASPRESS TRANSPORTES URGENTES LTDA, os produtos relacionados abaixo,
          para transporte até o destinatário informado nesta declaração. As
          mercadorias são particulares, sem valor comercial e não requer emissão
          de nota fiscal, dada sua natureza ou minha condição de não
          contribuinte. Declaro não haver mercadorias ilegais, visto que o
          conteúdo da mercadoria é inteiramente de responsabilidade do
          contratante.
        </Description>

        <SectionWrapper>
          <span className="title">Remetente</span>

          <div className="row">
            <span className="field">CNPJ</span>
            <span className="field fullWidth">
              {collectSenderData?.document}
            </span>
          </div>
          <div className="row">
            <span className="field">Nome/Razão Social</span>
            <span className="field fullWidth">{collectSenderData?.name}</span>
          </div>
          <div className="row">
            <span className="field">CEP</span>
            <span className="field blank">
              {collectSenderData?.address?.zipPostalCode}
            </span>
            <span className="field">Endereço</span>
            <span className="field fullWidth">
              {collectSenderData?.address?.streetAddress}
            </span>
            <span className="field">Número</span>
            <span className="field blank">
              {collectSenderData?.address?.streetAddressNumber}
            </span>
          </div>
          <div className="row">
            <span className="field">Complemento</span>
            <span className="field fullWidth">
              {collectSenderData?.address?.additional_Information}
            </span>
            <span className="field">Bairro</span>
            <span className="field fullWidth">
              {collectSenderData?.address?.suburb}
            </span>
            <span className="field">Cidade</span>
            <span className="field fullWidth">
              {collectSenderData?.address?.city}
            </span>
            <span className="field">Estado</span>
            <span className="field blank">
              {collectSenderData?.address?.state}
            </span>
          </div>
        </SectionWrapper>

        <SectionWrapper>
          <span className="title">Destinatário</span>

          <div className="row">
            <span className="field">CNPJ</span>
            <span className="field fullWidth">
              {collectRecipientData?.document}
            </span>
          </div>
          <div className="row">
            <span className="field">Nome/Razão Social</span>
            <span className="field fullWidth">
              {collectRecipientData?.name}
            </span>
          </div>
          <div className="row">
            <span className="field">CEP</span>
            <span className="field blank">
              {collectRecipientData?.address?.zipPostalCode}
            </span>
            <span className="field">Endereço</span>
            <span className="field fullWidth">
              {collectRecipientData?.address?.streetAddress}
            </span>
            <span className="field">Número</span>
            <span className="field blank">
              {collectRecipientData?.address?.streetAddressNumber}
            </span>
          </div>
          <div className="row">
            <span className="field">Complemento</span>
            <span className="field fullWidth">
              {collectRecipientData?.address?.additional_Information}
            </span>
            <span className="field">Bairro</span>
            <span className="field fullWidth">
              {collectRecipientData?.address?.suburb}
            </span>
            <span className="field">Cidade</span>
            <span className="field fullWidth">
              {collectRecipientData?.address?.city}
            </span>
            <span className="field">Estado</span>
            <span className="field blank">
              {collectRecipientData?.address?.state}
            </span>
          </div>
        </SectionWrapper>

        <SectionWrapper>
          <span className="title">Mercadorias</span>

          <Table>
            <thead>
              <tr>
                <td>Descrição dos Bens</td>
                <td>Quantidade</td>
                <td>Peso</td>
                <td>Valor Unitário</td>
                <td>Valor Total</td>
                <td>Observações</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ height: 80 }}> </td>
                <td style={{ height: 80 }}> </td>
                <td style={{ height: 80 }}> </td>
                <td style={{ height: 80 }}> </td>
                <td style={{ height: 80 }}> </td>
                <td style={{ height: 80 }}> </td>
              </tr>
            </tbody>
          </Table>
        </SectionWrapper>

        <SectionWrapper style={{ marginBottom: 40 }}>
          <span className="title">Local e Data Declaração</span>
          <div style={{ height: 60 }} />

          <SectionWrapper style={{ margin: 0 }}>
            <span className="title">Declarante/Remetente</span>

            <Table>
              <thead>
                <tr>
                  <td>Nome e Documento</td>
                  <td>Assinatura</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ height: 60 }}> </td>
                  <td style={{ height: 60 }}> </td>
                </tr>
              </tbody>
            </Table>
          </SectionWrapper>
        </SectionWrapper>
      </Content>
    </Container>
  );
};

export default DeclarationForm;
